module.exports = __webpack_public_path__ + "assets/img/appartment-building.a6d16b3c.jpg";